import React from 'react';
import App from './app';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
import reportWebVitals from './reportWebVitals';

reportWebVitals();
ReactDOM.render( <App /> , document.getElementById('root'))